import {
  queryArticleList,
  getAllArticleCounts,
  setArticleBadgeStatus,
  setArticleTopStatus,
  passOfflineArticle,
  rejectOfflineArticle,
  manOfflineArticle,
  onlineViewArticle,
  importInArticleCategory,
  importExArticleCategory,
  importExportLog,
  listContentBusinessForUserMan,
} from "@/api/man";
import { exportExcel } from "@/api/importExport";

// -------------------------- 导出 ----------------------------//
export function getOutArticleCategory(that, importExportCode) {
  that.uploadShow = true;
  let param = that.exFormData();
  exportExcel({ param, importExportCode, tenantId: param.tenantId })
    .then((res) => {
      if (res) {
        loopImportExportLog(2, that, importExportCode);
      }
    })
    .catch((err) => {
      console.log(err);
      that.uploadShow = false;
      that.$message.error(err.msg);
    });
}
/**
 * 导出导出code值(importExportCode):
    1 文章关联类目导入导出
    2 问答关联类目导入导出
    3 内容敏感词导入导出
    4 运营端答案导出
    5 运营端文章导出
    6 问答导入
 * @param {*} importExportCode
 * @param {*} that
 */
export function closeDialog(importExportCode, that) {
  if (importExportCode === 1) {
    that.dialogContentVisible = false;
  }
  if (importExportCode === 2) {
    //
  }
  if (importExportCode === 3) {
    //
  }
  if (importExportCode === 4) {
    //
  }
  if (importExportCode === 5) {
    that.dialogContentVisible = false;
  }
  if (importExportCode === 6) {
    that.dialogTableVisible = false;
  }
}
export function showFailTips(res, that) {
  if (
    res.importExportCode === 1 ||
    res.importExportCode === 2 ||
    res.importExportCode === 13 ||
    res.importExportCode === 17 ||
    res.importExportCode === 18
  ) {
    if (res.importExportType === 1) {
      that.isImportErrorShow = res.importExportStatus == 4 && res.failFileUrl;
      if (res.importExportStatus === 3) {
        that.$message.success(`导入成功`);
      }
      if (res.importExportStatus === 4) {
        that.$message.error(`导入失败`);
      }
      if (res.errorMsg) {
        that.$message.error(res.errorMsg);
      }
      if (res.importExportStatus == 4 && res.failFileUrl) {
        that.failImportUrl = res.failFileUrl;
      }
    } else {
      that.isExportErrorShow = res.importExportStatus == 4 && res.failFileUrl;
      if (res.errorMsg) {
        that.$message.error(res.errorMsg);
      }
      if (res.importExportStatus === 3) {
        that.$message.success(`导出成功`);
      }
      if (res.importExportStatus === 4) {
        that.$message.error(`导出失败`);
      }
      if (res.importExportStatus == 4 && res.failFileUrl) {
        that.failExportUrl = res.failFileUrl;
      }
    }
  }
  if (res.importExportCode === 2) {
    //
  }
  if (res.importExportCode === 3) {
    //
  }
  if (res.importExportCode === 4) {
    //
  }
  if (res.importExportCode === 5) {
    that.isExportArticleShow = res.importExportStatus == 4;
  }
  // 问答
  if (res.importExportCode === 6) {
    if (res.importExportType === 1) {
      that.isDownShow = res.importExportStatus == 4 && res.failFileUrl;
      if (res.importExportStatus === 3) {
        that.$message.success(`导入成功`);
      }
      if (res.importExportStatus == 4) {
        if (res.errorMsg) {
          that.$message.error(res.errorMsg);
        }
        if (res.failFileUrl) {
          that.errUrl = res.failFileUrl;
        }
      }
    }
  }
  if (res.importExportCode === 9) {
    if (res.errorMsg) {
      that.$message.error(res.errorMsg);
    }
    if (res.importExportType === 1) {
      that.isSaleImportErrorShow =
        res.importExportStatus == 4 && res.failFileUrl;
      if (res.importExportStatus === 3) {
        that.$message.success(`导入成功`);
      }
      if (res.importExportStatus === 4) {
        that.$message.error(`导入失败`);
      }
      if (res.importExportStatus == 4 && res.failFileUrl) {
        that.failImportSaleUrl = res.failFileUrl;
      }
    } else {
      that.isSaleExportErrorShow =
        res.importExportStatus == 4 && res.failFileUrl;
      if (res.importExportStatus === 3) {
        that.$message.success(`导出成功`);
      }
      if (res.importExportStatus === 4) {
        that.$message.error(`导出失败`);
      }
      if (res.importExportStatus == 4 && res.failFileUrl) {
        that.failExportSaleUrl = res.failFileUrl;
      }
    }
  }

  if (res.importExportCode === 8) {
    if (res.errorMsg) {
      that.$message.error(res.errorMsg);
    }
    if (res.importExportType === 1) {
      that.isSaleImportErrorShow =
        res.importExportStatus == 4 && res.failFileUrl;
      if (res.importExportStatus === 3) {
        that.$message.success(`导入成功`);
      }
      if (res.importExportStatus === 4) {
        that.$message.error(`导入失败`);
      }
      if (res.importExportStatus == 4 && res.failFileUrl) {
        that.failImportSaleUrl = res.failFileUrl;
      }
    } else {
      that.isSaleExportErrorShow =
        res.importExportStatus == 4 && res.failFileUrl;
      if (res.importExportStatus === 3) {
        that.$message.success(`导出成功`);
      }
      if (res.importExportStatus === 4) {
        that.$message.error(`导出失败`);
      }
      if (res.importExportStatus == 4 && res.failFileUrl) {
        that.failExportSaleUrl = res.failFileUrl;
      }
    }
  }
  if (res.importExportCode === 14 || res.importExportCode === 15) {
    let sucText = `批量内容免审成功`;
    let errText = `批量内容免审失败`;
    if (res.importExportCode === 15) {
      sucText = `批量下线内容成功`;
      errText = `批量下线内容失败`;
    }
    if (res.errorMsg) {
      that.$message.error(res.errorMsg);
    }
    if (res.importExportStatus === 3) {
      that.$message.success(sucText);
    }
    if (res.importExportStatus === 4) {
      that.$message.error(errText);
    }
  }
}

//轮询查询
export function loopImportExportLog(type, that, importExportCode) {
  that.timer = setInterval(() => {
    getImportExportLog(type, that, importExportCode);
  }, 3000);
}
//轮询查看类目导入导出方法
export function getImportExportLog(type, that, importExportCode) {
  let params = {
    importExportCode,
    importExportType: type,
  };
  console.log("商品导出：", params);
  importExportLog(params)
    .then((res) => {
      if (res.importExportStatus == 3) {
        that.uploadShow = false;

        if (res.importExportType == 1) {
          showFailTips(res, that);
        } else if (res.importExportType == 2) {
          // that.isExportErrorShow = false
          showFailTips(res, that);
          // that.dialogOutCategoryVisible = false
          closeDialog(res.importExportCode, that);
          that.$message.success(`导出成功`);
          window.location.href = res.outFileUrl;
        }
        if (that.timer) {
          clearInterval(that.timer);
          that.timer = null;
        }
      } else if (res.importExportStatus == 4) {
        that.uploadShow = false;
        if (res.importExportType == 1) {
          showFailTips(res, that);
        } else if (res.importExportType == 2) {
          showFailTips(res, that);
        }
        if (that.timer) {
          clearInterval(that.timer);
          that.timer = null;
        }
      }
    })
    .catch((err) => {
      console.log("获取列表数据出错");
      console.log(err);
    });
}

// -------------------------- 导入 ----------------------------//
// 上传文件校验
export function fileChange(e, that, limit) {
  if (!limit) {
    limit = 1;
  }
  let fileData = e.target.files[0];
  let extension = fileData.name.split(".")[1];
  let extensionList = ["xls", "xlsx"];
  if (extensionList.indexOf(extension) < 0) {
    that.$message.error("上传文件必须为Excel文件");
    e.target.value = "";
    return false;
  }
  const isLt1M = fileData.size / 1024 / 1024 < limit;
  if (!isLt1M) {
    that.$message.error("上传文件不能超过1M");
    that.fileResult = "";
    that.fileName = "";
    let fileVal = that.$refs.file;
    fileVal.value = "";
    return false;
  }
  that.fileName = fileData;
  getBase64(fileData).then((file) => {
    that.fileBase64 = file.replace(/data.+?;base64,/, "");
  });
}
// 上传文件转base64
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    let fileResult = "";
    reader.readAsDataURL(file);
    reader.onload = function () {
      fileResult = reader.result;
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.onloadend = function () {
      resolve(fileResult);
    };
  });
}
export function uploadCategoryExl(that, importExportCode) {
  let file = that.fileName;
  if (file == "" || !file) {
    that.$message.error("请选择上传的文件");
    return false;
  } else {
    that.uploadShow = true;
    that.$message({
      message: "文件上传中，请勿刷新页面和关闭窗口！",
      type: "warning",
    });
  }
  importInArticleCategory({
    tenantId: that.$commonJs.getTenantId(),
    fileBase64: that.fileBase64,
    fileName: file.name.split(".")[0],
    importExportCode,
  })
    .then((res) => {
      if (res) {
        loopImportExportLog(1, that, importExportCode);
      }
    })
    .catch((err) => {
      console.log(err);
      that.fileResult = "";
      that.fileName = "";
      let fileVal = that.$refs.file;
      fileVal.value = "";
      that.uploadShow = false;
      that.$message.error(err.msg);
    });
}
